<template>
  <button
    :class="{
      'bg-gray-100 text-efblue-9': category === value,
      'bg-efblue-9 text-white': category !== value
    }"
    class="rounded-none flex flex-col focus:bg-transparent hover:bg-transparent focus:text-efblue-9 hover:text-efblue-9 p-10 text-left duration-100"
    @click="$emit('click')"
  >
    <div class="flex items-center justify-between w-full mb-2">
      <h3 class="font-bold">{{ title }}<span class="sr-only">.</span></h3>
      <CheckIcon
        v-if="category === value"
        class="w-4 h-4 min-w-4 min-h-4 fill-current ml-3"
      />
    </div>
    <p class="text-sm">
      {{ info }}
    </p>
  </button>
</template>

<script>
export default {
  name: 'Category',
  props: {
    title: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  }
};
</script>
